<template>
  <div>
    <div :class="{bold: isFolder}" @click="toggle">
          <div v-if="!isFolder">
              <input  type="checkbox" class="form-check-input" v-model="item.selected" :id="'check_' + item.menuIndex "> 
              <label v-if="!isFolder" class="form-check-label" :for="'check_' + item.menuIndex">
                {{ item.name }} 
                
              </label>
          </div>
          <div v-else>
              <span :style="{color : item.menuTitle == 1 ? 'brown':''}">{{ item.name }} </span> 
              <span v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span>
          </div>
                    
        </div>

        <ul  v-show="isOpen" v-if="isFolder">
         
          
          <tree-item
            
            class="item"
            v-for="(child, index) in item.children"
            :key="index"
            :item="child"
          
          ></tree-item>
          

         <!-- <li class="add" @click="$emit('add-item', item)">+</li>-->
        </ul>
      

  </div>  
</template>
<script>
export default {
  name: 'TreeItem', // necessary for self-reference
  props: {
    item: Object
  },
  data() {
    return {
      isOpen: false
    }
  },

  
  computed: {
          isFolder: function() {
            return this.item.children && this.item.children.length;
          }
        },
  mounted()
    {
        //console.log(this.item)
    },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.isOpen = !this.isOpen
      }
    },
   /*
    makeFolder() {
            if (!this.isFolder) {
              this.$emit("make-folder", this.item);
              this.isOpen = true;
            }
          },
    
    */
  }
}
</script>
<style scoped>



.bold {
  font-weight : bold;
  font-size   : large;
  color       : blue;
}
ul {
  padding-left    : 1em;
  line-height     : 1.5em;
  /*list-style-type : dot;*/
  

}
.form-check-input{
  cursor: pointer;
}
.form-check-label
{
  cursor: pointer;
}
</style>